import type { Transfer } from './types';

export const mockTransfers: Transfer[] = [
  {
    id: 'txfr-10091',
    sender: 'Nexora Capital LLC',
    senderAccount: '****4821',
    receiver: 'Bridgeport Clearing',
    receiverAccount: '****3302',
    amount: 284500,
    fee: 142.25,
    currency: 'USD',
    method: 'SWIFT',
    status: 'completed',
    risk: 82,
    initiatedBy: 'Marcus Reid',
    initiatedAt: '04/29 12:34',
    settledAt: '04/29 12:36',
  },
  {
    id: 'txfr-10090',
    sender: 'Vantage Payments',
    senderAccount: '****2293',
    receiver: 'Orion Bank NA',
    receiverAccount: '****8814',
    amount: 51200,
    fee: 25.6,
    currency: 'USD',
    method: 'ACH',
    status: 'processing',
    risk: 44,
    initiatedBy: 'Priya Nambiar',
    initiatedAt: '04/29 12:31',
    settledAt: null,
  },
  {
    id: 'txfr-10089',
    sender: 'Crestfield Holdings',
    senderAccount: '****6610',
    receiver: 'Meridian Trust',
    receiverAccount: '****5521',
    amount: 9800,
    fee: 4.9,
    currency: 'USD',
    method: 'Wire',
    status: 'failed',
    risk: 91,
    initiatedBy: 'Kwame Asante',
    initiatedAt: '04/29 12:28',
    settledAt: null,
  },
  {
    id: 'txfr-10088',
    sender: 'Luminos Financial',
    senderAccount: '****7741',
    receiver: 'Apex Clearing Co.',
    receiverAccount: '****2201',
    amount: 126000,
    fee: 63,
    currency: 'USD',
    method: 'ACH',
    status: 'completed',
    risk: 18,
    initiatedBy: 'Sarah Okonkwo',
    initiatedAt: '04/29 12:22',
    settledAt: '04/29 12:24',
  },
  {
    id: 'txfr-10087',
    sender: 'Redwood Ventures',
    senderAccount: '****9903',
    receiver: 'Summit Bank Corp',
    receiverAccount: '****4417',
    amount: 47300,
    fee: 23.65,
    currency: 'USD',
    method: 'SWIFT',
    status: 'pending',
    risk: 67,
    initiatedBy: 'Marcus Reid',
    initiatedAt: '04/29 12:19',
    settledAt: null,
  },
  {
    id: 'txfr-10086',
    sender: 'Halcyon Treasury',
    senderAccount: '****0094',
    receiver: 'Pinnacle FX Ltd',
    receiverAccount: '****7730',
    amount: 890000,
    fee: 445,
    currency: 'USD',
    method: 'Wire',
    status: 'processing',
    risk: 29,
    initiatedBy: 'Priya Nambiar',
    initiatedAt: '04/29 12:14',
    settledAt: null,
  },
  {
    id: 'txfr-10085',
    sender: 'Irongate Partners',
    senderAccount: '****3318',
    receiver: 'Clearfield Bank',
    receiverAccount: '****6609',
    amount: 32100,
    fee: 16.05,
    currency: 'USD',
    method: 'ACH',
    status: 'reversed',
    risk: 78,
    initiatedBy: 'Kwame Asante',
    initiatedAt: '04/29 12:08',
    settledAt: null,
  },
  {
    id: 'txfr-10084',
    sender: 'Solara Payments',
    senderAccount: '****1127',
    receiver: 'Northgate Capital',
    receiverAccount: '****8843',
    amount: 215000,
    fee: 107.5,
    currency: 'USD',
    method: 'SWIFT',
    status: 'completed',
    risk: 12,
    initiatedBy: 'Sarah Okonkwo',
    initiatedAt: '04/29 12:03',
    settledAt: '04/29 12:05',
  },
  {
    id: 'txfr-10083',
    sender: 'Blackstone Advisory',
    senderAccount: '****5530',
    receiver: 'Harbor Trust Co.',
    receiverAccount: '****1182',
    amount: 73400,
    fee: 36.7,
    currency: 'USD',
    method: 'RTP',
    status: 'completed',
    risk: 8,
    initiatedBy: 'Marcus Reid',
    initiatedAt: '04/29 11:58',
    settledAt: '04/29 11:58',
  },
  {
    id: 'txfr-10082',
    sender: 'Citadel Remittance',
    senderAccount: '****4409',
    receiver: 'Westfield FX',
    receiverAccount: '****3375',
    amount: 18600,
    fee: 9.3,
    currency: 'USD',
    method: 'ACH',
    status: 'pending',
    risk: 55,
    initiatedBy: 'Priya Nambiar',
    initiatedAt: '04/29 11:44',
    settledAt: null,
  },
  {
    id: 'txfr-10081',
    sender: 'Everest Capital',
    senderAccount: '****2210',
    receiver: 'Delphi Settlements',
    receiverAccount: '****9921',
    amount: 340000,
    fee: 170,
    currency: 'USD',
    method: 'Wire',
    status: 'completed',
    risk: 22,
    initiatedBy: 'Kwame Asante',
    initiatedAt: '04/29 11:31',
    settledAt: '04/29 11:34',
  },
  {
    id: 'txfr-10080',
    sender: 'Titan Payments LLC',
    senderAccount: '****8807',
    receiver: 'Cascade Bank',
    receiverAccount: '****6614',
    amount: 5200,
    fee: 2.6,
    currency: 'USD',
    method: 'RTP',
    status: 'failed',
    risk: 73,
    initiatedBy: 'Sarah Okonkwo',
    initiatedAt: '04/29 11:18',
    settledAt: null,
  },
];
